import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { C, O, A } from 'shared/helpers';
import { editorRenderables as renderables } from 'shared/constants';
import { useSelector, useDispatch } from 'react-redux';

import Styles from './Outros.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faEdit } from '@fortawesome/free-solid-svg-icons';

import Header from 'components/Header/Header';
import Editor from 'components/ProductEditor/ProductEditor';
import Table from './Table/Table';

import { Creators as reduxProdutos } from 'store/ducks/produtos';

import { useEditableContext } from 'shared/hooks';
import PrintButton from 'components/PrintButton/PrintButton';
import WithPermission from 'components/Template/WithPermission/WithPermission';

const INITIAL_FORM = {
  nome: '',
  classificacao: '',
  user_id: '',
  ...O(renderables, A(0, renderables.length)),
};

export default function Outros({ match }) {
  const { Outros, Selected } = Styles;
  const { id } = match.params;
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user.data);
  const PEM = useSelector((state) =>
    state.pems.data.find((pem) => String(pem.id) === String(id)),
  );
  const produtos = useSelector((state) => state.produtos.data || []);

  const notOnlyEtec = !user.roles.some((x) =>
    x.name.toLowerCase().includes('etec'),
  );

  const [adding, setAdding] = useState(false);

  useEditableContext(adding);

  const [form, setForm] = useState(INITIAL_FORM);

  useEffect(() => {
    dispatch(
      reduxProdutos.getProdutos(
        (x) => String(x.user_id) === String(user.id) || notOnlyEtec,
      ),
    );
  }, [id, dispatch, user, notOnlyEtec]);

  useEffect(() => {
    const id = !notOnlyEtec ? user.id : null;
    setForm((f) => ({ ...f, user_id: id }));
  }, [user, notOnlyEtec]);

  const registerProduct = (form, etecStatus, id = null) => {
    dispatch(reduxProdutos.addProduto(form, !etecStatus, id));
  };

  const tableRef = useRef();

  const close = useCallback(() => {
    setAdding(false);
  }, []);

  return (
    <div className={Outros}>
      <Editor
        open={adding}
        close={close}
        renderables={renderables}
        form={form}
        setter={(e) => {
          const {
            target: { value, name },
          } = e;
          setForm((f) => ({ ...f, [name]: value, user_id: user.id }));
        }}
        submit={registerProduct}
        etecStatus={!notOnlyEtec}
        id={id}
      />
      <Header
        title={'BALANÇO NUTRICIONAL UTILIZADO PELO PRODUTOR - PRODUTO OUTROS'}
        icon={faEdit}
        style={{ width: '95vw' }}
      >
        <WithPermission permission='produtos.create'>
          <button
            id='adicionar'
            className={C([adding, Selected])}
            onClick={() => {
              setForm({ ...INITIAL_FORM, user_id: user.id });
              setAdding(!adding);
            }}
          >
            <FontAwesomeIcon icon={faPlus} />
          </button>
        </WithPermission>
        <PrintButton fitElements={[tableRef]} />
      </Header>
      <Table
        tableRef={tableRef}
        produtos={produtos.filter((p) => p.user_id === user.id)}
        renderables={renderables}
        selector={(x) => {
          setForm({ ...x, user_id: PEM.user_id || user.id });
          setAdding(true);
        }}
      />
    </div>
  );
}

Outros.propTypes = {
  match: PropTypes.any.isRequired,
};
